// State
export const state = () => ({
  loading: false,
  domainSetting: [],
  nsLists: [],
  domainSettingToken: {}
})

// Actions
export const actions = {
  // get manual adjustments
  async getDomainSetting({ commit, state }, params) {
    try {
      commit('setDomainSettingToken', { domain: this.$axios.CancelToken.source() })
      commit('loading', true)
      await this.$axios
        .get(`/marketing-tools/marketing-domains`, {
          params,
          cancelToken: state.domainSettingToken.domain.token
        })
        .then(response => {
          commit('setDomainSetting', response?.data)
          commit('loading', false)
        })
        .catch(() => {
          commit('loading', false)
        })
    } catch (e) {
      commit('loading', false)
    }
  },
  // Create manual
  async create({ commit, rootGetters }, data) {
    commit('loading', true)
    const response = await this.$axios
      .post(`/marketing-tools/marketing-domains`, data)
      .then(res => {
        commit('loading', false)
        return true
      })
      .catch(() => {
        commit('loading', false)
        return false
      })
    return response
  },

  async delete({ commit }, id) {
    commit('loading', true)
    const response = await this.$axios
      .delete(`/marketing-tools/marketing-domains/${id}`)
      .then(() => {
        commit('loading', false)
        return true
      })
      .catch(() => {
        commit('loading', false)
        return false
      })
    return response
  },

  async checkDomainSetting({ commit }, id) {
    commit('loading', true)
    const response = await this.$axios
      .put(`/marketing-tools/marketing-domains/check/${id}`, {})
      .then(res => {
        commit('loading', false)
        commit('setNsLists', res.data)
        return res.data
      })
      .catch(() => {
        commit('loading', false)
        return false
      })
    return response
  },

  async checkDomainSettingDns({ commit }, ns) {
    commit('loading', true)
    const response = await this.$axios
      .get(`/marketing-tools/marketing-domains/dns/${ns}`)
      .then(res => {
        commit('loading', false)
        commit('setNsLists', res.data)
      })
      .catch(() => {
        commit('loading', false)
        return false
      })
    return response
  }
}

// Mutations
export const mutations = {
  loading: (state, type) => {
    state.loading = type
  },
  setDomainSetting: (state, data) => {
    state.domainSetting = data
  },
  clearDomainSetting: state => {
    state.domainSetting = []
  },
  setNsLists: (state, data) => {
    state.nsLists = data
  },
  setDomainSettingToken: (state, data) => {
    const oldData = { ...state.DomainSettingToken }
    state.domainSettingToken = {
      ...oldData,
      ...data
    }
  }
}
